const updateMetaTag = (name, content, isProperty = false) => {
  let selector = isProperty
    ? `meta[property="${name}"]`
    : `meta[name="${name}"]`;

  let element = document.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");

    if (isProperty) {
      element.setAttribute("property", name);
    } else {
      element.setAttribute("name", name);
    }

    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

export const setSEO = ({ title, description }) => {
  if (title) document.title = title;

  if (description) {
    updateMetaTag("description", description);
    updateMetaTag("og:description", description, true);
    updateMetaTag("twitter:description", description);
  }

  if (title) {
    updateMetaTag("og:title", title, true);
    updateMetaTag("twitter:title", title);
  }
};
